/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
var DataContext = React.createContext({});
export default DataContext;